import React from 'react';
import styled from 'astroturf/react';
import routes from 'js/core_pre_webpack/routes';
import { Button } from 'js/design_system/Button';
import { Icon } from 'js/design_system/Icon';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import _Container from "PodcastLibraryAd3-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd3.tsx?styleId=Container";
import _Header from "PodcastLibraryAd3-Header.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd3.tsx?styleId=Header";
import _Divider from "PodcastLibraryAd3-Divider.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd3.tsx?styleId=Divider";
import _HeaderText from "PodcastLibraryAd3-HeaderText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd3.tsx?styleId=HeaderText";
import _CardsWrapper from "PodcastLibraryAd3-CardsWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd3.tsx?styleId=CardsWrapper";
import _Card from "PodcastLibraryAd3-Card.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd3.tsx?styleId=Card";
import _CardContent from "PodcastLibraryAd3-CardContent.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd3.tsx?styleId=CardContent";
import _Thumbnail from "PodcastLibraryAd3-Thumbnail.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd3.tsx?styleId=Thumbnail";
import _ThumbnailImage from "PodcastLibraryAd3-ThumbnailImage.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd3.tsx?styleId=ThumbnailImage";
import _TextContent from "PodcastLibraryAd3-TextContent.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd3.tsx?styleId=TextContent";
import _Title from "PodcastLibraryAd3-Title.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd3.tsx?styleId=Title";
import _Author from "PodcastLibraryAd3-Author.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd3.tsx?styleId=Author";
import _StyledButton from "PodcastLibraryAd3-StyledButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd3.tsx?styleId=StyledButton";
import _IconWrapper from "PodcastLibraryAd3-IconWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/PodcastLibraryAd3.tsx?styleId=IconWrapper";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const Header = /*#__PURE__*/styled("div", null, {
  displayName: "Header",
  styles: _Header
});

const Divider = /*#__PURE__*/styled("div", null, {
  displayName: "Divider",
  styles: _Divider
});

const HeaderText = /*#__PURE__*/styled("p", null, {
  displayName: "HeaderText",
  styles: _HeaderText
});

const CardsWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "CardsWrapper",
  styles: _CardsWrapper
});

const Card = /*#__PURE__*/styled("a", null, {
  displayName: "Card",
  styles: _Card
});

const CardContent = /*#__PURE__*/styled("div", null, {
  displayName: "CardContent",
  styles: _CardContent
});

const Thumbnail = /*#__PURE__*/styled("div", null, {
  displayName: "Thumbnail",
  styles: _Thumbnail
});

const ThumbnailImage = /*#__PURE__*/styled("img", null, {
  displayName: "ThumbnailImage",
  styles: _ThumbnailImage
});

const TextContent = /*#__PURE__*/styled("div", null, {
  displayName: "TextContent",
  styles: _TextContent
});

const Title = /*#__PURE__*/styled("p", null, {
  displayName: "Title",
  styles: _Title
});

const Author = /*#__PURE__*/styled("p", null, {
  displayName: "Author",
  styles: _Author
});

const StyledButton = /*#__PURE__*/styled(Button, null, {
  displayName: "StyledButton",
  styles: _StyledButton
});

const IconWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "IconWrapper",
  styles: _IconWrapper
});

interface PodcastData {
  id: number;
  workId: number;
  workTitle: string;
  workAuthors: string;
  workThumbnailUrl: string | null;
  source?: string;
}

interface Props {
  podcasts: PodcastData[];
}

/**
 * Podcast Library Ad 3 component that displays recommended podcasts.
 * Shows 2 podcast cards with thumbnails, titles, authors, and listen buttons.
 *
 * The listen button links to the podcast library with the podcast ID as a query
 * parameter to show the recommended/hoisted version.
 *
 * This component is automatically tracked with impression watching.
 */
export const PodcastLibraryAd3: React.FC<Props> = ({ podcasts }) => {
  const impressionSource = 'podcast_lib.home.ad-3';

  if (!podcasts || podcasts.length === 0) {
    return null;
  }

  const extra = {
    rec_type: podcasts[0]?.source,
  };

  return (
    <ImpressionWatcher active={true} source={impressionSource} extra={extra}>
      <Container>
        <Header>
          <Divider />
          <HeaderText>Podcasts you might like:</HeaderText>
        </Header>
        <CardsWrapper>
          {podcasts.map((podcast) => (
            <Card
              key={podcast.id}
              href={`${routes.podcast_library_url()}?recommendedPodcastId=${podcast.id}`}
            >
              <CardContent>
                <Thumbnail>
                  {podcast.workThumbnailUrl ? (
                    <ThumbnailImage src={podcast.workThumbnailUrl} alt="" />
                  ) : (
                    <div
                      style={{
                        width: '100%',
                        height: '100%',
                        background: '#f8f8fb',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Icon
                        name="article"
                        size={40}
                        style={{ color: '#dddde2' }}
                      />
                    </div>
                  )}
                </Thumbnail>
                <TextContent>
                  <Title>{podcast.workTitle}</Title>
                  <Author>By {podcast.workAuthors}</Author>
                </TextContent>
              </CardContent>
              <StyledButton>
                <IconWrapper>
                  <Icon name="headset" size={20} />
                </IconWrapper>
                Listen
              </StyledButton>
            </Card>
          ))}
        </CardsWrapper>
      </Container>
    </ImpressionWatcher>
  );
};
